type CreateRoute = {
	entity: string;
	limit: number;
	page: number;
	sort: string;
	customFilters: any;
	withRowCount?: boolean;
};

export const createRoute = (options: CreateRoute) => {
	const { entity, limit, page, sort, customFilters, withRowCount } = options;
	const rowCountParam = withRowCount ? "&meta=filter_count" : "";
	const queryParams = `limit=${limit}&sort=${sort}&page=${page}${rowCountParam}`;

	if (entity === "directus_users") {
		return `/users`;
	} else if (entity === "gap-allocator") {
		return `/gap-allocator?${queryParams}`;
	} else if (entity === "directus_roles") {
		return `/roles`;
	} else if (customFilters) {
		return `/records-custom-filter/${entity}?${queryParams}`;
	} else {
		return `/items/${entity}?${queryParams}`;
	}
};
